<div class="flex flex-row" style="align-items: center; margin-bottom: 25px;">
    <div class="part-mart-locat-header">{{store.Name}}</div>
    <div style="margin-left: auto;" class="part-mart-locat-header-label-min part-mart-locat-header-label-min-margin">Platform Status:</div>
    <p-dropdown class="part-mart-locat-header-label-min-margin" optionLabel="name" placeholder="Active"></p-dropdown>
    <div class="part-mart-locat-header-label-min part-mart-locat-header-label-min-margin">Store status:</div>
    <div *ngIf="store.IsClosed" class="part-location-status-closed">Closed</div>
    <div *ngIf="!store.IsClosed" class="part-location-status-open">Open</div>
</div>
<hr class="hr-border-line" />